<template>
  <div class="11">
    <div v-if="isEditorStatus">悬浮图标(请预览效果)</div>
    <div
      v-else
      :style="style"
      @click="jump(config.property_data.link_data[0].link_data)"
    >
      <img
        v-if="config.property_data.link_data[0]"
        :style="{ width: config.property_data.width + 'px' }"
        :src="config.property_data.link_data[0].image_url"
      />
    </div>
  </div>
</template>

<script>
import { redirectURL } from "@/js/jump";
import bridge from "@mk/mk-bridge";
import html2canvas from "html2canvas";

export default {
  name: "tms-fix-icon",
  props: ["config", "isEditorStatus"],
  computed: {
    style() {
      const Style = {};
      const {
        width,
        height,
        radius,
        right,
        bottom
      } = this.config.property_data;
      width && (Style.width = width + "px");
      height && (Style.height = height + "px");
      height && (Style.height = height + "px");
      radius && (Style.borderRadius = radius + "px");
      right && (Style.right = right + "px");
      bottom && (Style.bottom = bottom + "px");
      if (this.isEditorStatus === false) {
        Style.position = "fixed";
      } else {
        Style.opacity = 1;
      }
      return {
        "z-index": 1199,
        overflow: "hidden",
        ...Style
      };
    }
  },

  data() {
    return {};
  },
  components: {},
  created() {},
  methods: {
    jump(item) {
      if (this.config.property_data.open_download === 2) {
        this.downLoadImg();
        return;
      }
      if (this.isEditorStatus || !item) {
        return;
      }
      redirectURL(item.toString(), "seller");
    },
    //下载图片
    downLoadImg() {
      const body = window.document.getElementsByClassName("app")[0];
      html2canvas(body, {
        useCORS: true, //页面内使用了跨域的图片需要加useCORS: true，不然图片截图时会不存在
        // width: body.clientWidth,
        // height: body.clientHeight,
        scrollY: 0,
        scrollX: 0
      }).then(canvas => {
        // canvas为转换后的Canvas对象
        let oImg = new Image();
        oImg = canvas.toDataURL("image/png"); // 导出图片
        const ua = window.navigator.userAgent;
        if (ua.match(/Mockuai(Buyer)?\/([\d\.]+)/)) {
          bridge.request("downloadImage", { url: oImg });
        } else {
          var oA = document.createElement("a");
          oA.download = '下载文件.png'; // 设置下载的文件名，默认是'下载'
          oA.href = oImg;
          document.body.appendChild(oA);
          oA.click();
          oA.remove(); // 下载之后把创建的元素删除
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
